import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  omniAccountsItem,
  OmniBasicBodySchema,
  OmniBasicReconnectResponseSchema,
  OmniBasicResponseSchema,
  OmniTradeDeskBodySchema,
} from '../../shared/schemas/BasicSchema.js';

export const omniAuthBasicReconnect = defaultClient.mutation({
  url: 'omni-connector-service/auth/basic/authorize/reconnect' as const,
  method: 'POST',
  responseSchema: OmniBasicReconnectResponseSchema,
  requestSchema: OmniBasicBodySchema,
  processResponse: (data) => data,
});

export const omniAuthBasic = defaultClient.mutation({
  url: 'omni-connector-service/auth/basic/authorize' as const,
  method: 'POST',
  responseSchema: OmniBasicResponseSchema,
  requestSchema: OmniBasicBodySchema,
  processResponse: (data) => data,
});

export const omniTradeDeskAuth = defaultClient.mutation({
  url: 'omni-connector-service/auth/tradedesk/authorize' as const,
  method: 'POST',
  responseSchema: OmniBasicResponseSchema,
  requestSchema: OmniTradeDeskBodySchema,
  processResponse: (data) => data,
});

export type OmniAccountsItemType = z.infer<typeof omniAccountsItem>;
